import { UserResponse } from "@/models/user.model.ts";
import api from "@/lib/api.ts";
import { AxiosResponse } from "axios";

export async function getProfile() {
  return api
    .get("users/profile?include=subscriptions")
    .then((response: AxiosResponse<UserResponse>) => response.data);
}
